import { Result } from '@bcz/pen'

export function NotFound() {
  return <Result status="error" title="404" description="Not Found" />
}
